import { useContext } from 'react'
import { TimeFormatContext } from '../contexts/TimeFormatContext'

/** The user's clock format for set times; see TimeFormatProvider. */
export function useTimeFormat() {
  return useContext(TimeFormatContext)
}
